import { ReactElement, Suspense } from 'react';
import cc from 'classcat';
import { lazy as LazyImport } from 'utils/generic/lazy';
import { AToZData, TAtoZMenuConfigs } from 'interfaces/generic';
import { CenteredSpinnerWrapper } from './SportListViews/LevelView';

const { SportPage } = LazyImport(
  () => import(/* webpackChunkName: "sport-page" */ './SportPage')
);

const { CasinoPage } = LazyImport(
  () => import(/* webpackChunkName: "casino-page" */ './CasinoPage')
);

const { RacingPage } = LazyImport(
  () => import(/* webpackChunkName: "racing-page" */ './RacingPage')
);

type TTabContentsProps = {
  activeTab: AToZData | null;
  setVisible: (arg: boolean) => void;
  setOpen: (arg: boolean) => void;
  configs: TAtoZMenuConfigs;
  withArrows?: boolean;
};

export const TabContents = ({
  activeTab,
  setVisible,
  withArrows,
  setOpen,
  configs
}: TTabContentsProps): ReactElement => {
  const LoadingSpinerSportPage =
    activeTab?.category === 'sport' || activeTab?.category === 'esport'
      ? CenteredSpinnerWrapper()
      : null;

  return (
    <div
      className={cc(['tab-content', { 'tab-content__withArrows': withArrows }])}
    >
      {activeTab?.category ? (
        activeTab.category === 'sport' ? (
          <Suspense fallback={LoadingSpinerSportPage}>
            <SportPage
              isEsport={false}
              setOpen={setOpen}
              configs={configs}
              setVisible={setVisible}
              type={activeTab?.type || ''}
              isLive={activeTab?.type === 'live'}
            />
          </Suspense>
        ) : activeTab.category === 'esport' ? (
          <Suspense fallback={LoadingSpinerSportPage}>
            <SportPage
              isEsport
              type="esport"
              setOpen={setOpen}
              configs={configs}
              setVisible={setVisible}
            />
          </Suspense>
        ) : activeTab.category === 'racing' ? (
          <Suspense fallback={null}>
            <RacingPage
              setOpen={setOpen}
              aToZRacingSportsList={configs.aToZRacingSportsList}
            />
          </Suspense>
        ) : (
          <Suspense fallback={null}>
            <CasinoPage
              categoryIds={configs.categoryIds}
              setOpen={setOpen}
              setVisible={setVisible}
              type={activeTab?.type || ''}
              isLiveCasino={activeTab?.type === 'live-casino'}
            />
          </Suspense>
        )
      ) : null}
    </div>
  );
};
